import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import ModelComparisonTable from "@/components/features/ModelComparisonTable";
import WordGateSection from "@/components/features/WordGateSection";
import DVDifferenceSection from "@/components/features/DVDifferenceSection";
import RXTKeyFeatures from "@/components/features/RXTKeyFeatures";
import RXTHardwareSpecs from "@/components/features/RXTHardwareSpecs";
import RXTAudioCapabilities from "@/components/features/RXTAudioCapabilities";
import RXTControlSystem from "@/components/features/RXTControlSystem";
import RXTApplications from "@/components/features/RXTApplications";
import RXTBusinessBenefits from "@/components/features/RXTBusinessBenefits";
import MeetingSecuritySection from "@/components/features/MeetingSecuritySection";

const FeaturesAndBenefitsRXT4D = () => {
  const { t } = useLanguage();

  const handleViewProduct = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="mb-8">
        <Link
          to="/group/meeting-room"
          className="mb-8 inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Meeting Room / ReAX Room Solutions
        </Link>
        <h1 className="mb-4 text-4xl font-bold tracking-tight">
          ReAX Room Desktop Control Panels — Features & Benefits
        </h1>
        <p className="text-lg text-muted-foreground max-w-4xl">
          Aurora's RXT desktop control panel family offers 4-inch and 6-inch models, each available in two variants: the <strong>D</strong> (standard) and the <strong>DV</strong> (with integrated VPX AV over IP). Explore the features, technologies, and benefits that make these panels the most advanced all-in-one room solutions available.
        </p>
      </div>

      {/* D vs DV Explanation */}
      <DVDifferenceSection />

      {/* WordGate™ Technology */}
      <WordGateSection />

      {/* Model Comparison Table */}
      <ModelComparisonTable />

      {/* Key Features */}
      <RXTKeyFeatures />

      {/* Enhanced Meeting Security */}
      <MeetingSecuritySection />

      {/* Hardware Specifications */}
      <RXTHardwareSpecs />

      {/* Audio Capabilities */}
      <RXTAudioCapabilities />

      {/* Control System */}
      <RXTControlSystem />

      {/* Applications */}
      <RXTApplications />

      {/* Business Benefits */}
      <RXTBusinessBenefits />

      {/* Call to Action */}
      <div className="text-center bg-muted rounded-lg p-8">
        <h2 className="text-2xl font-bold mb-4">Ready to Learn More?</h2>
        <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
          Discover detailed specifications, documentation, and technical details for the complete ReAX Room suite of products.
        </p>
        <Link to="/group/meeting-room" onClick={handleViewProduct}>
          <Button size="lg">
            View Meeting Room / ReAX Room Solutions
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default FeaturesAndBenefitsRXT4D;
